const ORG_TYPE_OPTIONS = [
  {
    value: "seller",
    label: ($) => $.onboarding["Seller"],
  },
  {
    value: "vendor",
    label: ($) => $.onboarding["Vendor"],
  },
];

const CHANNEL_OPTIONS = [
  {
    value: "amazon",
    label: ($) => $.onboarding["Amazon"],
  },
  {
    value: "walmart",
    label: ($) => $.onboarding["Walmart"],
  },
];

export const ORG_CHANNEL_FILTER = {
  name: ($) => $.onboarding["Channel"],
  id: "org_type",
  format: "select",
  selectOptions: [
    {
      value: "all",
      label: ($) => $.onboarding["All Channels"],
    },
    ...CHANNEL_OPTIONS,
  ],
  override: true,
  defaultValue: "all",
  operator: "custom",
  filterFunction: (org, filterValue) => {
    if (filterValue !== "all") {
      return org?.org_type.toLowerCase() === filterValue.toLowerCase();
    }
    return true;
  },
};

export const ORG_TYPE_FILTER = {
  name: ($) => $.onboarding["Type"],
  id: "profile_type",
  format: "select",
  selectOptions: [
    {
      value: "all",
      label: ($) => $.onboarding["All Types"],
    },
    ...ORG_TYPE_OPTIONS,
  ],
  override: true,
  defaultValue: "all",
  operator: "custom",
  filterFunction: (org, filterValue) => {
    if (filterValue !== "all") {
      return org?.profile_type === filterValue;
    }
    return true;
  },
};
